module.exports = __webpack_public_path__ + "img/pulse.dcf45551.svg";